// eslint-disable-next-line max-classes-per-file
class FacetMoreLess extends HTMLElement {
  constructor() {
    super();

    this.clickCount = 0;
    this.filterItems = JSON.parse(this.querySelector('[data-filter-items]').innerHTML);
    this.itemsToFilter = null;

    if (!Object.values(this.filterItems)?.length === 0 || this.filterItems?.filter_values?.length <= 5) {
      this.querySelector('[data-id="more"]').style.display = 'none';

      return;
    }

    const selectedElementList = document.querySelector('.filter-selected-element-list');

    function handleChanges(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (selectedElementList) {
            const activeFiltersElement = selectedElementList.querySelector('[data-active-filters]');

            if (activeFiltersElement && selectedElementList.classList.contains('hidden')) {
              selectedElementList.classList.remove('hidden');
              selectedElementList.classList.add('flex');
            } else if (!activeFiltersElement && selectedElementList.classList.contains('flex')) {
              selectedElementList.classList.add('hidden');
              selectedElementList.classList.remove('flex');
            }
          }
        }
      }
    }

    if (selectedElementList) {
      const observer = new MutationObserver(handleChanges);

      observer.observe(selectedElementList, {
        childList: true,
        subtree: true,
      });
    }

    this.addEventListener('click', function (e) {
      if (e.target.dataset.id === 'more') {
        this.clickCount += 1;
      } else if (e.target.dataset.id === 'less') {
        this.clickCount -= 1;
      }

      if (this.filterItems?.filter_label === 'Color') {
        this.itemsToFilter = this.filterItems.filter_values.map(
          (item, index) => `
          <div class="py-3" data-filter-element>
            <label for="Filter-${item.param_name}--${index + 1}" class="flex items-center">
              <input
                type="checkbox"
                id="Filter-${item.param_name}--${index + 1}"
                class="
                ${
                  theme.collection.enableColorSwatches
                    ? `peer
                  absolute
                  left-0
                  top-0
                  -z-1
                  h-full
                  w-full
                  opacity-0`
                    : `peer
                    form-checkbox
                    mr-2
                    h-6
                    w-6
                    shrink-0
                    border-base-border
                    bg-base-body-background
                    text-base-body
                    rounded-form-element
                    checked:bg-[length:75%_75%]
                    focus:ring-0
                    focus:ring-opacity-0
                    focus:ring-offset-0
                    focus:ring-offset-transparent
                    disabled:bg-base-accent`
                }
                "
                name="${item.param_name}"
                  value="${item.label}"
                ${item.active && 'checked'}
                ${item.count === 0 && item.active === false && 'disabled'}
                >
                ${
                  theme.collection.enableColorSwatches
                    ? `
                <span class="
                  group
                  relative
                  mr-2
                  h-6
                  w-6
                  shrink-0
                  cursor-pointer
                  overflow-hidden
                  rounded-full
                  border
                  border-base-border
                  p-[1px]
                  transition-colors
                  duration-300
                  after:absolute
                  after:left-1/2
                  after:top-1/2
                  after:z-2
                  after:h-full
                  after:w-[1px]
                  after:-translate-x-1/2
                  after:-translate-y-1/2
                  after:rotate-45
                  after:bg-base-overlay-white
                  after:opacity-0
                  after:content-['']
                  peer-checked:border-base-body
                  peer-focus:border-base-body
                  peer-disabled:cursor-default
                  peer-disabled:after:opacity-100
                ">
                  <span
                    style="background-color: ${item.value};"
                    class="block h-full w-full group-[&.rounded-full]:rounded-full"
                  ></span>
                </span>
              `
                    : ''
                }
              <span class="peer-disabled:text-base-secondary">

                ${item.label} (${item.count})
              </span>
            </label>
          </div>
        `
        );
      } else {
        this.itemsToFilter = this.filterItems.filter_values.map(
          (item, index) =>
            `
          <div class="py-3 flex items-center" data-filter-element>
            <input
              type="checkbox"
              id="Filter-${item.param_name}-${index + 1}"
              class="
                peer
                form-checkbox
                mr-2
                h-6
                w-6
                shrink-0
                border-base-border
                bg-base-body-background
                text-base-body
                rounded-form-element
                checked:bg-[length:75%_75%]
                focus:ring-0
                focus:ring-opacity-0
                focus:ring-offset-0
                focus:ring-offset-transparent
                disabled:bg-base-accent
            "
              value="${item.value}"
              name="${item.param_name}"
              ${item.active && 'checked'}
              ${item.count === 0 && item.active === false && 'disabled'}
            >
            <label for="Filter-${item.param_name}-${index + 1}" class="w-full peer-disabled:text-base-secondary">
              ${item.label} (${item.count})
            </label>
          </div>
          `
        );
      }

      this.queryVar = this.filterItems?.filter_label === 'Color' ? 'colors' : 'square';

      const filterSlideContainer = this.parentElement.querySelector('[data-filter-slide-container]');

      this.insertAfterEl = filterSlideContainer || this.parentElement;

      if (this.clickCount >= 1) {
        this.querySelector('[data-id="less"]').style.display = 'inline';
      }

      if (e.target.dataset.id === 'less') {
        if (this.clickCount * 5 + 5 < this.itemsToFilter.length) {
          this.querySelector('[data-id="more"]').style.display = 'inline';
        }

        this.items = this.parentElement.querySelectorAll(`[data-filter-element]`);

        this.items.forEach((el, index) => {
          if (index + 1 > this.clickCount * 5 + 5) {
            el.remove();
          }
        });

        if (this.clickCount === 0) {
          this.querySelector('[data-id="less"]').style.display = 'none';
        }
      } else if (e.target.dataset.id === 'more') {
        if (this.clickCount * 5 + 5 >= this.itemsToFilter.length) {
          this.querySelector('[data-id="more"]').style.display = 'none';
        }

        this.insertAfterEl.insertAdjacentHTML(
          'beforeend',
          this.itemsToFilter.slice(this.clickCount * 5, this.clickCount * 5 + 5).join('')
        );
      }
    });
  }

  insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }
}

customElements.define('more-less', FacetMoreLess);

function debounce(fn, wait) {
  let t;

  return (...args) => {
    clearTimeout(t);

    return new Promise((resolve) => {
      t = setTimeout(() => resolve(fn(...args)), wait);
    });
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const formElement = this.querySelector('form');

    if (formElement) {
      formElement.addEventListener('input', this.debouncedOnSubmit.bind(this));
    } else {
      console.warn('Form element not found in FacetFiltersForm');
    }

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const filterSelectors = document.querySelectorAll('#filter-sortby, #filter-sortby-2');

    const self = this;

    filterSelectors.forEach(
      (filterSelector) =>
        filterSelector.addEventListener('change', function (e) {
          const id = this.getAttribute('id');
          let surplusFilter;

          if (id === 'filter-sortby') {
            surplusFilter = document.getElementById('filter-sortby-2');
          } else {
            surplusFilter = document.getElementById('filter-sortby');
          }

          const tempValue = surplusFilter.value;

          if (surplusFilter) surplusFilter.value = '';

          const dbSubmit = self.debouncedOnSubmit.bind(self, e);

          dbSubmit().then(() => (surplusFilter.value = tempValue));
        }),
      self
    );

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');

    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.checkActiveFilters();
    FacetFiltersForm.initMultiRange();

    history.replaceState({ searchParams: window.location.search.slice(1) }, '', window.location.href);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams =
        event.state && event.state.searchParams ? event.state.searchParams : window.location.search.slice(1);

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach((section) => {
      if (!section.section) {
        return;
      }

      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderPagination(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.triggerUpdateQuickViewEvent();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const { html } = FacetFiltersForm.filterData.find(filterDataUrl);

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.triggerUpdateQuickViewEvent();
  }

  static renderProductGridContainer(html) {
    const newHTML = new DOMParser().parseFromString(html, 'text/html');

    const newProductsGrid = newHTML.getElementById('product-grid');

    if (newProductsGrid) {
      document.getElementById('product-grid').innerHTML = newProductsGrid.innerHTML;
      document.getElementById('product-grid').classList.replace('grid-cols-1', 'grid-cols-2');
      document.getElementById('product-grid').classList.replace('lg:grid-cols-1', 'lg:grid-cols-5');
    } else {
      const emptyMarkup = newHTML?.querySelector('[data-empty-markup]');

      document.getElementById('product-grid').innerHTML = emptyMarkup.innerHTML;
      document.getElementById('product-grid').classList.replace('grid-cols-2', 'grid-cols-1');
      document.getElementById('product-grid').classList.replace('lg:grid-cols-5', 'lg:grid-cols-1');
    }

    const rerenderedPageEvent = new Event('collectionPageRerender');

    document.dispatchEvent(rerenderedPageEvent);
  }

  static renderPagination(html) {
    const paginationWrapper = document.getElementById('pagination-container');

    if (paginationWrapper) {
      paginationWrapper.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('pagination-container').innerHTML;
    }

    document.dispatchEvent(new CustomEvent('filterChange'));
  }

  static renderProductCount(html) {
    const updatedContainer = new DOMParser().parseFromString(html, 'text/html');
    let count = updatedContainer.getElementById('ProductCountDesktop');

    if (count) {
      count = count.innerHTML;
    }

    const totalProductsCount = updatedContainer.querySelector('[data-total-products-quantity]').dataset
      .totalProductsQuantity;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const productsContainer = document.querySelector('[data-total-products-quantity]');

    if (container) container.innerHTML = count;

    if (containerDesktop) containerDesktop.innerHTML = count;

    productsContainer?.setAttribute('data-total-products-quantity', totalProductsCount);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newFilter = parsedHTML.querySelector('#filter-main-open-close');

    if (newFilter) {
      document.querySelector('#filter-main-open-close').innerHTML = newFilter.innerHTML;
    }

    const newClearAll = parsedHTML.querySelector('[data-active-filter]');

    if (newClearAll) {
      document.querySelector('[data-active-filter]').outerHTML = newClearAll.outerHTML;
    }

    // The relevance of the code is questionable, since in elements with such IDs there is no class called `js-filter`
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
      '#FacetFiltersMobile .js-filter'
    );

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;

      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const filterSlideContainer = element.querySelector('[data-filter-slide-container]');
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    FacetFiltersForm.initMultiRange();
    const mobileFilters = document.getElementById('filter-main-open-close');

    if (window.innerWidth <= 1023 && mobileFilters) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (!mobileFilters.getAttribute('open')) {
              setTimeout(FacetFiltersForm.scrollToElementIfNeeded, 0);
              FacetFiltersForm.scrollToElementIfNeeded();
            }
          }
        }
      });

      observer.observe(mobileFilters, { attributes: true });
    } else {
      FacetFiltersForm.scrollToElementIfNeeded();
    }

    window.App.customCloseDetails();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.filter-selected-element-list'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.checkActiveFilters();
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;

      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const sectionId = document.getElementById('product-grid')?.dataset?.id;

    return [
      {
        section: sectionId,
      },
    ];
  }

  static checkActiveFilters() {
    const clearAllBtn = document.querySelector('facet-remove[data-facet-clear-all]');
    const containerForActiveFilters = document.querySelector('[data-active-filter]');

    const activeFilter = Array.from(document.querySelectorAll('#FacetsWrapperDesktop input')).find((input) => {
      if (input.type === 'number') {
        return input.value.trim().length;
      }

      return input.checked;
    });

    activeFilter ? FacetFiltersForm.renderClearAll(clearAllBtn) : FacetFiltersForm.hideClearAll(clearAllBtn);
  }

  static scrollToElementIfNeeded() {
    const containerForActiveFilters = document.querySelector('[data-active-filter]');
    const mainProductsContainer = document.getElementById('product-grid');
    const mainFiltersContainer = document.querySelector('[data-main-filter-container]');
    const headerHeight = mainFiltersContainer?.offsetHeight;
    const activeFiltersHeight = containerForActiveFilters?.offsetHeight;

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    if (
      containerForActiveFilters &&
      !isElementInViewport(mainProductsContainer) &&
      mainProductsContainer.getBoundingClientRect().top < 0
    ) {
      const topPos = containerForActiveFilters.classList.contains('hidden')
        ? mainProductsContainer.getBoundingClientRect().top + window.scrollY - headerHeight + activeFiltersHeight
        : mainProductsContainer.getBoundingClientRect().top + window.scrollY - headerHeight - activeFiltersHeight;

      window.scrollTo({
        top: topPos,
        behavior: 'smooth',
      });
    }
  }

  static initMultiRange() {
    const inputLeft = document.querySelector('[data-min-price]');

    if (!inputLeft) return;

    const inputRight = document.querySelector('[data-max-price]');
    const minInput = document.querySelector('[data-min-input]');
    const maxInput = document.querySelector('[data-max-input]');
    const thumbLeft = document.querySelector('[data-thumb-left]');
    const thumbRight = document.querySelector('[data-thumb-right]');
    const range = document.querySelector('[data-range]');

    function setLeftValue(input) {
      const min = +input.min;
      const max = +input.max;
      let { value } = input;

      value = Math.min(parseInt(value, 10), parseInt(inputRight.value, 10) - 1);

      const percent = ((value - min) / (max - min)) * 100;

      minInput.value = input.value;
      inputLeft.left = input.value;

      thumbLeft.style.left = `${percent.toFixed(2)}%`;
      range.style.left = `${percent.toFixed(2)}%`;
    }

    function setRightValue(input) {
      const min = +input.min;
      const max = +input.max;
      let { value } = input;

      value = Math.max(parseInt(value, 10), parseInt(inputLeft.value, 10) + 1);

      const percent = ((value - min) / (max - min)) * 100;

      thumbRight.style.right = `${(100 - percent).toFixed(2)}%`;
      range.style.right = `${(100 - percent).toFixed(2)}%`;

      maxInput.value = input.value;
      inputRight.value = input.value;
    }

    function initialize() {
      minInput.value ? setLeftValue(minInput) : setLeftValue(inputLeft);
      maxInput.value ? setRightValue(maxInput) : setRightValue(inputRight);
    }

    initialize();

    inputLeft.addEventListener('input', () => setLeftValue(inputLeft));
    inputRight.addEventListener('input', () => setRightValue(inputRight));
    minInput.addEventListener('input', () => setLeftValue(minInput));
    maxInput.addEventListener('input', () => setRightValue(maxInput));
  }

  static renderClearAll(clearAll) {
    clearAll.removeAttribute('hidden');
  }

  static hideClearAll(clearAll) {
    clearAll.setAttribute('hidden', true);
  }

  static triggerUpdateQuickViewEvent() {
    const updateQuickViewEvent = new CustomEvent('updateQuickView');

    document.dispatchEvent(updateQuickViewEvent);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Get existing search params
    const currentParams = new URLSearchParams(window.location.search);
    const searchQuery = currentParams.get('q');

    let formData;
    let searchParams;

    if (event?.target?.closest('form')) {
      formData = new FormData(event.target.closest('form'));
      searchParams = new URLSearchParams(formData);
    } else {
      const form = document.getElementById('FacetFiltersForm');

      formData = new FormData(form);
      searchParams = new URLSearchParams(formData);
    }

    // Preserve the search query if it exists
    if (searchQuery) {
      searchParams.set('q', searchQuery);
    }

    let hasSizeFilter = false;

    for (const [key, value] of searchParams.entries()) {
      if (key.includes('filter.v.option.størrelse')) {
        hasSizeFilter = true;
        break;
      }
    }

    // Add the custom 48 hour delivery filter if size filter is selected
    if (hasSizeFilter) {
      searchParams.set('filter.v.m.custom.fast_delivery', '1');
    } else {
      // Remove the custom filter if no size filter is selected
      // searchParams.delete('filter.v.m.custom.fast_delivery');
    }

    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minInput = document.querySelector('[data-min-input]');
    this.maxInput = document.querySelector('[data-max-input]');
    this.leftRange = this.querySelector('[data-min-price]');
    this.rightRange = this.querySelector('[data-max-price]');
    this.range = this.querySelector('[data-range]');

    this.minInput.addEventListener('input', this.updateMinRange.bind(this));
    this.maxInput.addEventListener('input', this.updateMaxRange.bind(this));

    this.leftRange.addEventListener('input', this.updateRange.bind(this));
    this.rightRange.addEventListener('input', this.updateRange.bind(this));

    this.setInitialValues();
  }

  setInitialValues() {
    const minValue = this.minInput.value || this.leftRange.min;
    const maxValue = this.maxInput.value || this.rightRange.max;

    this.leftRange.value = minValue;
    this.rightRange.value = maxValue;

    this.updateRange();
  }

  updateMinRange() {
    this.leftRange.value = this.minInput.value;
    this.updateRange();
  }

  updateMaxRange() {
    this.rightRange.value = this.maxInput.value;
    this.updateRange();
  }

  updateRange() {
    let min = parseInt(this.leftRange.value);
    let max = parseInt(this.rightRange.value);

    const minDistance = 0;
    const rangeMax = parseInt(this.rightRange.max);

    if (min < 0) min = 0;

    if (max > rangeMax) max = rangeMax;

    if (min > max - minDistance) min = max - minDistance;

    if (max < min + minDistance) max = min + minDistance;

    this.leftRange.value = min;
    this.rightRange.value = max;

    this.range.style.left = `${(min / rangeMax) * 100}%`;
    this.range.style.width = `${((max - min) / rangeMax) * 100}%`;

    this.minInput.value = min;
    this.maxInput.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');

    if (!link) return;

    link.addEventListener('click', (event) => {
      event.preventDefault();
      const url = event.currentTarget.href;
      const id = event.currentTarget.getAttribute('id');

      if (id === 'price-range' || id === 'clear-all') {
        const priceRanges = document.querySelectorAll('.range-slider__input');

        for (const rangeItem of priceRanges) {
          rangeItem.value = '';
        }
      }

      // Get the search params from the URL
      const searchParams = url.includes('?') ? url.split('?')[1] : '';

      // Preserve the search query if it exists
      const currentParams = new URLSearchParams(window.location.search);
      const searchQuery = currentParams.get('q');

      if (searchQuery) {
        const newParams = new URLSearchParams(searchParams);

        newParams.set('q', searchQuery);
        FacetFiltersForm.renderPage(newParams.toString(), event);
      } else {
        FacetFiltersForm.renderPage(searchParams, event);
      }
    });
  }
}
customElements.define('facet-remove', FacetRemove);

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');

  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');

  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
